export default {"src":"/_next/static/media/working.796f5ef9.svg","height":513,"width":513};